import React from 'react';
import {FaFacebook, FaYoutube, FaMapMarkerAlt, FaClock, FaPhone, FaHeart} from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white relative overflow-hidden">
            <div className="absolute inset-0 bg-black/20"></div>
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
                    {/* Logo and Description */}
                    <div className="lg:col-span-1">
                        <div className="flex items-center space-x-3 mb-6">
                            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center shadow-lg">
                                <img 
                                    src="/logo_eecf_w192.png" 
                                    alt="EECF Logo" 
                                    className="w-10 h-10 object-contain"
                                />
                            </div>
                            <div>
                                <h3 className="text-xl font-bold text-white">EECF</h3>
                                <p className="text-sm text-blue-200 font-medium">基督教法国华人教会</p>
                            </div>
                        </div>
                        <p className="text-gray-300 text-sm leading-relaxed mb-6">
                            法国华人教会2025年的主题目标「建造家庭」
                        </p>
                    </div>

                    {/* Meeting Information */}
                    <div>
                        <h4 className="text-lg font-semibold text-white mb-6 pb-3 border-b border-blue-500/30">聚会信息</h4>
                        <div className="space-y-5">
                            <div className="flex items-start space-x-4">
                                <FaMapMarkerAlt className="w-5 h-5 text-blue-400 mt-1 flex-shrink-0" />
                                <div>
                                    <p className="text-sm font-semibold text-blue-200">地址</p>
                                    <p className="text-sm text-gray-300 leading-relaxed">97 Rue Julien Lacroix 75020 Paris, France</p>
                                </div>
                            </div>
                            <div className="flex items-start space-x-4">
                                <FaClock className="w-5 h-5 text-blue-400 mt-1 flex-shrink-0" />
                                <div>
                                    <p className="text-sm font-semibold text-blue-200">时间</p>
                                    <p className="text-sm text-gray-300">礼拜日 15:30-17:00</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Contact Information */}
                    <div>
                        <h4 className="text-lg font-semibold text-white mb-6 pb-3 border-b border-blue-500/30">联系我们</h4>
                        <div className="space-y-5">
                            <div className="flex items-start space-x-4">
                                <FaPhone className="w-5 h-5 text-blue-400 mt-1 flex-shrink-0" />
                                <div>
                                    <p className="text-sm font-semibold text-blue-200">电话</p>
                                    <a 
                                        href="tel:+33123456789" 
                                        className="text-sm text-gray-300 hover:text-blue-300 transition-colors duration-200"
                                    >
                                        +33 6 23 82 11 51
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Social Media */}
                    <div>
                        <h4 className="text-lg font-semibold text-white mb-6 pb-3 border-b border-blue-500/30">关注我们</h4>
                        <div className="space-y-4">
                            <a 
                                href="https://www.facebook.com/EECF26"
                                className="inline-flex items-center space-x-3 px-5 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl hover:from-blue-700 hover:to-blue-800 transition-all duration-200 w-full shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaFacebook className="w-5 h-5" />
                                <span className="text-sm font-semibold">Facebook</span>
                            </a>
                            <a 
                                href="https://youtube.com/@eecf"
                                className="inline-flex items-center space-x-3 px-5 py-3 bg-gradient-to-r from-red-600 to-red-700 text-white rounded-xl hover:from-red-700 hover:to-red-800 transition-all duration-200 w-full shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaYoutube className="w-5 h-5" />
                                <span className="text-sm font-semibold">YouTube</span>
                            </a>
                        </div>
                    </div>
                </div>

                {/* Copyright */}
                <div className="border-t border-gray-700 mt-12 pt-8">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <p className="text-sm text-gray-400 mb-4 md:mb-0">
                            &copy; 2025 EECF - 基督教法国华人教会. 保留所有权利.
                        </p>
                        <div className="flex items-center space-x-2 text-gray-400">
                            <FaHeart className="w-3 h-3 text-red-400" />
                            <span className="text-xs">愿神祝福你</span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer; 